export enum RuleTypeEnum {
  /**
   * 基本规则
   */
  Normal = 'normal',
  /**
   * 特殊规则
   */
  Special = 'special',
}

export enum PlaceLevelEnum {
  /**
   * 省
   */
  Province = 1,
  /**
   * 市
   */
  City,
  /**
   * 区
   */
  District,
}

const monthData = new Array(31).fill(0)?.map((_, index) => ({
  label: index + 1 + '日',
  value: index + 1,
}));

export const MonthDatePickerData = new Array(12).fill(0)?.map((_, index) => ({
  label: index + 1 + '月',
  value: index + 1,
  children: monthData,
}));

export const multiCalculateDescList = [
  {
    label: '一段式计算',
    value: false,
    tip: '仅匹配一个时间跨度计算费用规则',
  },
  {
    label: '多段式计算',
    value: true,
    tip: '按照每一段时间跨度分别计算费用规则，总规则等于每段时间跨度规则计算的费用之和',
  },
];
